import React from 'react';
import { usePqDataManager } from '../../providers/PqDataManagerProvider';
import { transformHTMLParserLinks } from '../../../../utils/rewriteLink/rewriteLink';

/**
 * This feature is not often used. It is a field that populates underneath the form and benefits.
 */
export default function DisclaimerText() {
    const {
        pqMappingContent: { disclaimerText },
    } = usePqDataManager();

    return <>{disclaimerText && transformHTMLParserLinks(disclaimerText)}</>;
}
